import { PARENT_EMAIL_ROUTES, ROUTES } from './vars';

export const FIRST_ASSESSMENT_DATE = '1970-01-02T00:00:00.000+01:00';
export const LAST_ASSESSMENT_DATE = '1970-01-03T00:00:00.000+01:00';

export const API_ERRORS = {
  NOT_ENOUGH_SUBSCRIPTIONS: 'Not enough subscriptions',
  USERNAME_ALREADY_EXISTS: 'Username Already Registered',
  EMAIL_ALREADY_EXISTS: 'The email already exists',
  DUPLICATE_STUDENT: 'Student already exists',
};

export const PUBLIC_PATHS = [
  `${ROUTES.parent_email}${PARENT_EMAIL_ROUTES.signup}`,
  `${ROUTES.parent_email}${PARENT_EMAIL_ROUTES.consent}`,
  `${ROUTES.parent_email}${PARENT_EMAIL_ROUTES.unsubscribe}`,
];
